module.exports = __webpack_public_path__ + "img/con3.c071ddd2.png";